import { Redirect, Route, Switch } from 'react-router';
import { Layout } from '@components/layout';
import { ProtectedRoute } from '@components/protected-route';
import DealDeDuplicatorPage from './deals/de-dupe';
import EditDealPage from './deals/edit';
import DealSearchPage from './deals/search';

import LoginPage from './login';
import CreateDealPage from './deals/create-deal';
import { CreateCompanyPage, EditCompanyPage } from './company/company-actions';
import SearchCompanyPage from './company/search';
import { NewContent, EditContent, CreateContent } from './content/content-actions';
import { SideBarItem } from '@components/layout/sidebar-item';
import { FcSearch, HandShakeIcon } from '@icon/react-icons';
import { ListSubheader } from '@material-ui/core';
import CompanyDefaultIcon from '@icon/company-default';
import ContentDefaultIcon from '@icon/content-default';
import SearchContentPage from './content/search';
import SearchCosmosPage from './cosmos/search';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CompanyDedupePage from './company/de-dupe';
// import SearchCompanyContentRelations from './company-content/search';
import CreateRelationPage from './company-content/create-relation';
import EditRelationPage from './company-content/edit-relation';
import SearchRelations from './company-content/relation-search';
import SearchRelationsBeta from './company-content-beta/relation-search';
import EditServiceRelationPage from './company-service/edit-relation';
import SearchServiceRelations from './company-service/relation-search';
import SearchPersonRelations from './company-to-person/relation-search';
import DomainBlacklisted from './domain-blacklist/relation-search';
import EditCompanyToPersonRelation from './company-to-person/edit';
import AddCompanyToPersonRelation from './company-to-person/add';
import AddPersonToContentRelation from './person-content/add';
import SearchServicesMaster from './service-management/services-master-search';
import CreateServiceMasterPage from './service-management/create-services-master';
import EditServiceMasterPage from './service-management/edit-services-master';
import SearchCompanyRequest from './company-request/company-request-search';
import SearchSubtypeMaster from './deal-subtype-management/deal-subtype-master-search';
import CreateSubtypeMasterPage from './deal-subtype-management/create-deal-subtype-master';
import EditDealSubtypeMasterPage from './deal-subtype-management/edit-deal-subtype-master';
import SearchRegionCountry from './region-country-master/region-country-master-search';
import CreateRegionCountryMasterPage from './region-country-master/create-region-country-master';
import EditRegionCountryMasterPage from './region-country-master/edit-region-country-master';
import CompanyMappingSearchPage from './company-mapping/search';
import CreateCompanyMappingPage from './company-mapping/create-company-mapping';
import EditCompanyMappingPage from './company-mapping/edit';
import { LandingPage } from './landing-page/landing-page';
import HoldingDataSearchPage from './holding-data/search';
import HoldingDataSearchBetaPage from './holding-data-beta/search';
import EditHoldingData from './holding-data/edit';
import EditHoldingDataBeta from './holding-data-beta/edit';
import SearchBadgesMaster from './badge-management/badges-master-search';
import CreateBadgeMaster from './badge-management/create-badges-master';
import EditBadgeMasterPage from './badge-management/edit-badges-master';
import SearchPersonsMaster from './person-management/person-master-search';
import CreatePersonMaster from './person-management/create-person-master';
import EditPersonMasterPage from './person-management/edit-person-master';
import SellerCatalogPage from './seller-catalog/search';
// import MlIntel from './ml-intel/ml-intel-search';
// import CreateMlIntel from './ml-intel/create-ml-intel';
import DefaultErrorPage from './default-error-page/default-error-page';
import CompanyMedia from './media/search'
import PersonMedia from './person-media/search'
import AddBlacklistDomain from './domain-blacklist/add';
import DatabaseLogsSearchPage from './database-logs/search';
import ContentDedupePage from './content/de-dupe';
import PersonDedupePage from './person-management/de-dupe';
import DatabaseLogsSecondary from './database-log-secondary/search';
// C3 Page - Cast/Crew/Content components
import C3PageSearch from './c3-page/search';
import C3PageCreate from './c3-page/create';
import EditC3Relation from './c3-page/edit/edit-c3-relation';
import ContentMappingSearchPage from './content-mapping/search';
import CreateContentMappingPage from './content-mapping/create-content-mapping';
import EditContentMappingPage from './content-mapping/edit';
import {CompanyReputationPage} from './company-reputation-score/company-reputation-score-page';
import QuotesPoliciesSearch from './quotes-policies/search/qp-search';
import AddQPPage from './quotes-policies/add/add-qp';
import EditQuotesandPolices from './quotes-policies/edit';
import ReplicateC2P from './company-to-person/replicate-c2p/replicate-c2p';
import CompanyMatchingSearchPage from './company-matching/search';
import EditC2CViewMappingPage from './company-mapping/edit-c2c';
import S3ManagerForm from './s3-manager/s3-manager-form';
import { FaFolderOpen } from 'react-icons/fa';
import AnalyticsDashboard from './datalogs-secondary-analysis/analytics-dashboard';
import ContentMatchingSearchPage from './content-matching';
import DuplicateSpotterContentPage from './content-duplicate-spotter/duplicate-spotter';
import ApolloEnrichedContacts from './apollo-enrichment-contact/apollo-enriched-contacts';

/**
 * Deli App router. Factory for all routes to the app, with/without layout.
 */
export default function DeliRoutes() {
  return (
    <Switch>
      <Route path="/login" exact component={LoginPage} />
      <ProtectedRoute>
        <Layout sidebar={SideBarItems}>
          <Switch>
            {/** Deals */}
            <Route path="/deals/search" exact component={DealSearchPage} />
            <Route path="/deals/new" exact component={CreateDealPage} />
            <Route path="/deals/edit/:id" exact component={EditDealPage} />
            <Route path="/deals/merge/:ids" exact component={DealDeDuplicatorPage} />
            {/** Company  */}
            <Route path="/company/search" exact component={SearchCompanyPage} />
            <Route path="/company/new" exact component={CreateCompanyPage} />
            <Route path="/company/edit/:id" exact component={EditCompanyPage} />
            <Route path="/company/merge/:ids" exact component={CompanyDedupePage} />
            <Route path="/company/media" exact component={CompanyMedia} />
            {/** Company Mapping */}
            <Route path="/company-mapping/search" exact component={CompanyMappingSearchPage} />
            <Route path="/company-mapping/new" exact component={CreateCompanyMappingPage} />
            <Route
              path="/company-mapping/edit-c2c/:company1_vtr_id"
              exact
              component={EditC2CViewMappingPage}
            />
             <Route
              path="/company-mapping/edit/:vtr_id"
              exact
              component={EditCompanyMappingPage}
            />
            {/** Comapnay Mapping */}
            {/** Content */}
            <Route path="/content/search" exact component={SearchContentPage} />
            <Route path="/content/new" exact component={NewContent} />
            <Route path="/content/edit/:id" exact component={EditContent} />
            <Route path="/content/merge/:ids" exact component={ContentDedupePage} />
            <Route path="/person-management/merge/:ids" exact component={PersonDedupePage} />
            <Route path="/content/create/:gnid" exact component={CreateContent} />
            {/** Content */}
            {/** Cosmos */}
            <Route path="/cosmos/search" exact component={SearchCosmosPage} />
            {/* Company Matching */}
            <Route path="/company-matching/search" exact component={CompanyMatchingSearchPage} />
                    {/** Content Matching */}    
            <Route path="/content-matching/search" exact component={ContentMatchingSearchPage} />
            <Route path="/duplicate-spotter/content" exact component={DuplicateSpotterContentPage} />
            {/** Cosmos */}
            {/* <Route
              path="/company-content/search/:company_vtr_id"
              exact
              component={SearchCompanyContentRelations}
            /> */}
            <Route path="/company-content/search" exact component={SearchRelations} />
            <Route path="/company-content-beta/search" exact component={SearchRelationsBeta} />
            <Route path="/company-service/search" exact component={SearchServiceRelations} />
            <Route path="/company-person/search" exact component={SearchPersonRelations} />
            <Route path="/domain-blacklist/search" exact component={DomainBlacklisted} />
            <Route path="/domain-blacklist/add" exact component={AddBlacklistDomain} />
            <Route path="/company-person/add" exact component={AddCompanyToPersonRelation} />
            <Route path="/company-person/new" exact component={ReplicateC2P} />
            <Route path="/company-person/edit/:person_company_rel_id" exact component={EditCompanyToPersonRelation} />
            {/* Person to Content Relations */}
            <Route path="/person-content/add" exact component={AddPersonToContentRelation} />
            {/*             For C3 Page - Cast/Crew/Content            */}
            <Route path="/c3-page/search" exact component={C3PageSearch} />
            <Route path="/c3-page/add" exact component={C3PageCreate} />
            <Route path="/c3-page/edit/:c3_rel_id" exact component={EditC3Relation} />
              <Route path="/content-mapping/search" exact component={ContentMappingSearchPage} />
                       <Route path="/content-mapping/new" exact component={CreateContentMappingPage} />
            <Route
              path="/content-mapping/edit/:content1_vtr_id"
              exact
              component={EditContentMappingPage}
            />
 
            <Route path="/company-reputation-score" exact component={CompanyReputationPage}/>
            <Route path="/s3-manager" exact component={S3ManagerForm}/>
            <Route path='/quotes-policies/search' exact component = {QuotesPoliciesSearch}/>
            <Route path='/quotes-policies/new' exact component = {AddQPPage}/>
            <Route path='/quotes-policies/edit/:vtr_id' exact component = {EditQuotesandPolices}/>
            <Route path="/company-content/new" exact component={CreateRelationPage} />
            <Route
              path="/company-content/:company_vtr_id/edit/:relationId"
              exact
              component={EditRelationPage}
            />
            <Route
              path="/company-service/:company_vtr_id/edit/:relationId"
              exact
              component={EditServiceRelationPage}
            />
            {/* 
            For services management
            */}
            <Route path="/service-management/search" exact component={SearchServicesMaster} />
            <Route path="/service-management/new" exact component={CreateServiceMasterPage} />
            <Route
              path="/service-management/edit/:serviceMasterId"
              exact
              component={EditServiceMasterPage}
            />
            {/* 
            For company requests
          */}
            <Route path="/company-request/search" exact component={SearchCompanyRequest} />
            {/** Refresh the current Route */}
            <Route
              path="/refresh"
              exact
              component={() => {
                const history = useHistory();
                useEffect(() => history.goBack(), []);
                return <></>;
              }}
            />
            {/* 
            For subtype management
          */}
            <Route path="/deal-subtype-master/search" exact component={SearchSubtypeMaster} />
            <Route path="/deal-subtype-master/new" exact component={CreateSubtypeMasterPage} />
            <Route
              path="/deal-subtype-master/edit/:subTypeMapId"
              exact
              component={EditDealSubtypeMasterPage}
            />
            <Route path="/region-country-master/search" exact component={SearchRegionCountry} />
            <Route
              path="/region-country-master/new"
              exact
              component={CreateRegionCountryMasterPage}
            />
            <Route
              path="/region-country-master/edit/:regionCountryMasterId"
              exact
              component={EditRegionCountryMasterPage}
            />
            {/** Holding Data GVD */}
            <Route path="/holding-data/search" exact component={HoldingDataSearchPage} />
            <Route path="/database-logs/search" exact component={DatabaseLogsSearchPage} />
           {/*  <Route path="/database-logs-secondary/search" exact component={DatabaseLogsSecondary} /> */}
            <Route path="/database-logs-secondary/search" exact component={AnalyticsDashboard}
            />
            <Route path="/holding-data/edit/:vtr_id" exact component={EditHoldingData} />
            <Route path="/seller-catalog/search" exact component={SellerCatalogPage} />
            <Route path="/holding-data-beta/edit/:vtr_id" exact component={EditHoldingDataBeta} />

            <Route path="/holding-data-beta/search" exact component={HoldingDataSearchBetaPage} />
            {/* 
            For badges management
          */}
            <Route path="/badge-management/search" exact component={SearchBadgesMaster} />
            <Route path="/badges-management/new" exact component={CreateBadgeMaster} />
            <Route
              path="/badge-management/edit/:badgeMasterId"
              exact
              component={EditBadgeMasterPage}
            />
            {/* 
            For person management
          */}
            <Route path="/person-management/search" exact component={SearchPersonsMaster} />
            <Route path="/person-management/new" exact component={CreatePersonMaster} />
            <Route
              path="/person-management/edit/:personMasterId"
              exact
              component={EditPersonMasterPage}
            />
            <Route path="/person/media" exact component={PersonMedia} />
            <Route path="/person-management/apollo" exact component={ApolloEnrichedContacts} />
            <Route path="/error-page" exact component={DefaultErrorPage} />

            {/* for ML Intel */}
            {/* <Route path="/ml-intel/search" exact component={MlIntel} />
            <Route path="/ml-intel/new/:mlArticleId" exact component={CreateMlIntel} /> */}
            {/** Landing Page */}
            <Route path="/landing-page" exact component={LandingPage} />
            {/** Default Route */}
            <Redirect to="/landing-page" />
          </Switch>
        </Layout>
      </ProtectedRoute>
    </Switch>
  );
}

const SideBarItems = ({ closeDrawer }) => (
  <div>
    <div>
      {/* div to be added to make each section have its own sticky header */}
      {/* disabled sticky , becuase headers are not required to be sticky */}
      <ListSubheader disableSticky>Deals Intel</ListSubheader>
      <SideBarItem icon={<FcSearch />} to="/deals/search" onClick={closeDrawer}>
        Search Deals
      </SideBarItem>
      <SideBarItem icon={<HandShakeIcon color="secondary" />} to="/deals/new" onClick={closeDrawer}>
        New Deal
      </SideBarItem>
    </div>
    <div>
      <ListSubheader disableSticky>Companies</ListSubheader>
      <SideBarItem icon={<FcSearch />} to="/company/search" onClick={closeDrawer}>
        Search Companies
      </SideBarItem>
      <SideBarItem
        icon={<CompanyDefaultIcon height="2em" width="2em" />}
        to="/company/new"
        onClick={closeDrawer}>
        New Company
      </SideBarItem>
      <SideBarItem icon={<FcSearch />} to="/company-request/search" onClick={closeDrawer}>
        Company Request
      </SideBarItem>
      <SideBarItem icon={<FcSearch />} to="/company/media" onClick={closeDrawer}>
      Media
    </SideBarItem>
    </div>
    <ListSubheader disableSticky>Content</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/content/search" onClick={closeDrawer}>
      Search Content
    </SideBarItem>
    <SideBarItem
      icon={<ContentDefaultIcon height="2em" width="2em" />}
      to="/content/new"
      onClick={closeDrawer}>
      New Content
    </SideBarItem>
     <ListSubheader disableSticky>Person Management</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/person-management/search" onClick={closeDrawer}>
      Search Persons
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/person-management/new"
      onClick={closeDrawer}>
      New Person
    </SideBarItem>
     <SideBarItem icon={<FcSearch />} to="/person/media" onClick={closeDrawer}>
      Person Media
    </SideBarItem>
    <SideBarItem icon={<FcSearch />} to="/person-management/apollo" onClick={closeDrawer}>
      Apollo Contacts
    </SideBarItem>
     <ListSubheader disableSticky>Company to Content Relations</ListSubheader>
   {/*  <SideBarItem icon={<FcSearch />} to="/company-content/search" onClick={closeDrawer}>
      Search Relations
    </SideBarItem> */}
    <SideBarItem icon={<FcSearch />} to="/company-content-beta/search" onClick={closeDrawer}>
      Search Relations
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/company-content/new"
      onClick={closeDrawer}>
      New Relation
    </SideBarItem>
     <ListSubheader disableSticky>Company to Company Relations</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/company-mapping/search" onClick={closeDrawer}>
      Search C2C Relations
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/company-mapping/new"
      onClick={closeDrawer}>
      New C2C Relation
    </SideBarItem>
    <ListSubheader disableSticky>Company To Person Relations</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/company-person/search" onClick={closeDrawer}>
      Search C2P
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/company-person/add"
      onClick={closeDrawer}>
      New C2P
    </SideBarItem>
    <ListSubheader disableSticky>C3 - Cast/Crew/Content</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/c3-page/search" onClick={closeDrawer}>
      Search C3 relations
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/c3-page/add"
      onClick={closeDrawer}>
      New C3 relation
    </SideBarItem>
     <ListSubheader disableSticky>Content to Content Relations</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/content-mapping/search" onClick={closeDrawer}>
      Search C2 Relations
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/content-mapping/new"
      onClick={closeDrawer}>
      New C2 Relation
    </SideBarItem>
    <ListSubheader disableSticky>Matching & Mapping</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/company-matching/search" onClick={closeDrawer}>
      Company Matching
    </SideBarItem>
    <SideBarItem icon={<FcSearch />} to="/content-matching/search" onClick={closeDrawer}>
      Content Matching
    </SideBarItem>
     <ListSubheader disableSticky>Company to Service Relations</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/company-service/search" onClick={closeDrawer}>
      Service Attributes
    </SideBarItem>
    <ListSubheader disableSticky>Services Management</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/service-management/search" onClick={closeDrawer}>
      Search Services
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/service-management/new"
      onClick={closeDrawer}>
      New Service
    </SideBarItem>
      <ListSubheader disableSticky>S3 Manager</ListSubheader>
      <SideBarItem   icon={<FaFolderOpen  size={24} color="#2563EB"/>}  to="/s3-manager" onClick={closeDrawer}>
        Manage S3
      </SideBarItem>
    {/* <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/deal-subtype-master/new"
      onClick={closeDrawer}>
      New Deal Subtype
    </SideBarItem> */}
    {/* <ListSubheader disableSticky>COSMOS</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/cosmos/search" onClick={closeDrawer}>
      COSMOS API
    </SideBarItem> */}
    <ListSubheader disableSticky>Badges Management</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/badge-management/search" onClick={closeDrawer}>
      Search Badges
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/badges-management/new"
      onClick={closeDrawer}>
      New Badge
    </SideBarItem>
    <ListSubheader disableSticky>Domain Blacklisted</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/domain-blacklist/search" onClick={closeDrawer}>
      Search domain
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/domain-blacklist/add"
      onClick={closeDrawer}>
      Add domain
    </SideBarItem>
    {/* <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/company-person/add"
      onClick={closeDrawer}>
      New C2P
    </SideBarItem> */}
    {/* <ListSubheader disableSticky>ML Intel</ListSubheader> */}
    {/* <SideBarItem icon={<FcSearch />} to="/ml-intel/search" onClick={closeDrawer}>
      ML Intel Search
    </SideBarItem> */}
     <ListSubheader disableSticky>Deal SubType Management</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/deal-subtype-master/search" onClick={closeDrawer}>
      Search Subtypes
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/deal-subtype-master/new"
      onClick={closeDrawer}>
      New Deal Subtype
    </SideBarItem>
    <ListSubheader disableSticky>Territory Management</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/region-country-master/search" onClick={closeDrawer}>
      Search Region Country
    </SideBarItem>
    <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/region-country-master/new"
      onClick={closeDrawer}>
      New Region Country
    </SideBarItem>
    <ListSubheader disableSticky>COSMOS</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/holding-data/search" onClick={closeDrawer}>
      Search COSMOS
    </SideBarItem>
    <SideBarItem icon={<FcSearch />} to="/seller-catalog/search" onClick={closeDrawer}>
      Seller Catalogue
    </SideBarItem>
    <ListSubheader disableSticky>Quotes & Policies (QP)</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/quotes-policies/search" onClick={closeDrawer}>
      Search QP
    </SideBarItem>
     <SideBarItem
      icon={<HandShakeIcon color="secondary" height="2em" width="2em" />}
      to="/quotes-policies/new"
      onClick={closeDrawer}>
      New QP
    </SideBarItem>
    <ListSubheader disableSticky>Database logs</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/database-logs/search" onClick={closeDrawer}>
      Search
    </SideBarItem>
    <ListSubheader disableSticky>Database logs Secondary</ListSubheader>
    <SideBarItem icon={<FcSearch />} to="/database-logs-secondary/search" onClick={closeDrawer}>
      Search
    </SideBarItem>
  </div>
)
